module.exports = __webpack_public_path__ + "img/p5.36a90373.png";